class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this)),
    );
  }

  open() {
    const wrapper = document.querySelector(".cart-notification-wrapper");
    if (!wrapper) {
      return;
    }

    wrapper.style.display = "block";

    $(".cart-notification-wrapper").addClass("is-opened");
    $("body").addClass("overflow-hidden");
    this.notification.classList.add("animate", "active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true },
    );
    var weeks_message = $(document)
      .find("product-info .order-block .weekss")
      .html();
    if (weeks_message) {
      $(document)
        .find(
          "#cart-notification #cart-notification-product .cart-notification-weekss",
        )
        .html(weeks_message);
    }
    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    $(".cart-notification-wrapper").removeClass("is-opened");
    $("body").removeClass("overflow-hidden");
    this.notification.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;

    if (!parsedState) {
      this.isProcessing = false;
      return;
    }

    this.cartItemKey = parsedState.key;

    let hasAnyContent = false;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      if (!sectionElement) {
        return;
      }

      const sectionHTML =
        parsedState.sections && parsedState.sections[section.id];
      if (!sectionHTML) {
        return;
      }

      try {
        const innerHTML = this.getSectionInnerHTML(
          sectionHTML,
          section.selector,
        );
        if (innerHTML) {
          sectionElement.innerHTML = innerHTML;
          hasAnyContent = true;
        } else {
        }
      } catch (error) { }
    });

    if (!hasAnyContent) {
      if (parsedState.item_count !== undefined) {
        const cartIconBubble = document.getElementById("cart-icon-bubble");
        if (cartIconBubble) {
          const existingContent = cartIconBubble.innerHTML;
          if (!existingContent.includes(parsedState.item_count)) {
            cartIconBubble.innerHTML =
              "<span>" + parsedState.item_count + "</span>";
          }
        }
      }
    }

    if (this.header) this.header.reveal();
    this.open();

    setTimeout(() => {
      this.isProcessing = false;
    }, 100);
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-notification-button",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
